import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Router } from "@angular/router";
import { Project } from "../../interfaces/project";

@Injectable()
export class ProjectService {
  env: any = environment;

  constructor(private http: HttpClient, private router: Router) {}

  getProjects() {
    return new Promise((resolve, reject) => {
      this.http
        .get<any>(this.env.managirUrl + "/projects", {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.ProjectResponse.projects);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  getProjectByShortId(shortId): Promise<Project> {
    return new Promise((resolve, reject) => {
      const params = new HttpParams().set("shortId", shortId);
      this.http
        .get<any>(this.env.managirUrl + "/projects", {
          params: params,
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.ProjectResponse.projects[0]);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
          /**
           * check if user has access on project and if project does exist
           */
          if (error.status === 404 || error.status === 403) {
            this.router.navigate(["/" + error.status]);
          }
        });
    });
  }

  async getStakeholders(projectId) {
    let response = await this.http
      .get<any>(
        this.env.managirUrl + "/projects/getStakeholders/" + projectId,
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .toPromise();
    return response;
  }

  getProjectById(projectId) {
    return new Promise((resolve, reject) => {
      this.http
        .get<any>(this.env.managirUrl + "/projects/" + projectId, {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.ProjectResponse.projects[0]);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
          /**
           * check if user has access on project and if project does exist
           */
          if (error.status === 404 || error.status === 403) {
            this.router.navigate(["/" + error.status]);
          }
        });
    });
  }

  createProject(project) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(this.env.managirUrl + "/projects", project, {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.ProjectResponse.projects[0]);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  updateProject(project) {
    return new Promise((resolve, reject) => {
      this.http
        .put<any>(this.env.managirUrl + "/projects/" + project._id, project, {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.message);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  setEstimatePassword(project) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(
          this.env.managirUrl + "/projects/setEstimatePassword/" + project._id,
          { estimatePassword: project.planningPokerPassword },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response.message);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  setQuestionnairePassword(project) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(
          this.env.managirUrl +
            "/projects/setQuestionnairePassword/" +
            project._id,
          { questionnairePassword: project.questionnairePassword },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response.message);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  shareProject(projectId, addresses) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(
          this.env.managirUrl + "/projects/share/" + projectId,
          { addresses: addresses },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  removeUserFromProject(projectId, userId) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(
          this.env.managirUrl + "/projects/removeUser/" + projectId,
          { userId: userId },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  removeInvitation(projectId, email) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(
          this.env.managirUrl + "/projects/removeInvitation/" + projectId,
          { email: email },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  endParticipation(projectId) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(
          this.env.managirUrl + "/projects/endParticipation/" + projectId,
          {},
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  deleteProjectById(projectId) {
    return new Promise((resolve, reject) => {
      this.http
        .delete<any>(this.env.managirUrl + "/projects/" + projectId, {
          headers: { "Content-Type": "application/json" },
        })
        .toPromise()
        .then((response) => {
          resolve(response.message);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }

  syncWithIssueTracker(projectId) {
    return new Promise((resolve, reject) => {
      this.http
        .post<any>(
          this.env.managirUrl + "/projects/syncWithIssueTracker/" + projectId,
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .toPromise()
        .then((response) => {
          resolve(response.message);
        })
        .catch((error) => {
          console.log(error);
          reject(error);
        });
    });
  }
}



// WEBPACK FOOTER //
// /agir/src/app/services/project/project.service.ts